import React, { useState, useContext, useEffect } from "react";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import FormBuilder from "../FormBuilder/FormBuilder";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import { EWContext } from "../../../context/EWContext";
import { getFormAnswers } from "../../../utils/utils";

function EligibilityQuestionsForm(props) {
    const [accountState, setAccountState] = useContext(EWContext);

    const {
        questions: { eligibility: questions },
        answers: { eligibility: eligibilityAnswers },
        customErrors,
        conditionSpecificBehaviors,
    } = accountState;

    const [loading, setLoading] = useState(false);
    const [errorFields, setErrorFields] = useState(true);
    const [eligibilityFormAnswers, setEligibilityAnswers] =
        useState(eligibilityAnswers);
    const { handleNext, handleBack, group } = props;

    /**Displaying the Error messages */
    const [errorInForm, setErrorInForm] = useState({
        message: customErrors.genericError,
        genericMessage: customErrors.contactError,
        labelButton: "Back",
        error: false,
    });

    /**On the basis of error setting the state */
    useEffect(() => {
        if (errorInForm.error) {
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                ...{
                    submitAttempts: prevAccountState.submitAttempts + 1,
                    eligibilityError: errorInForm,
                },
            }));
        }
    }, [errorInForm, setAccountState]);

    useEffect(() => {
        if (eligibilityAnswers.length > 0) {
            const formIsAnswered = eligibilityAnswers.every((field) => {
                if(field.type === "date") {
                    if(field.value == "Invalid Date") {
                        return false
                    }
                    let dateRange =  questions.find(ques => ques.id === field.id).field.rangeDates;

                    if(dateRange?.minDate?.date) {

                        if(new Date(field.value ) < new Date(dateRange.minDate.date)){
                            return false
                        }
                    } 

                    if(dateRange?.maxDate?.date) {
                        
                        if(new Date(field.value) > new Date(dateRange.maxDate.date)) {
                            return false
                        }
                    }
                }
                return  field ? (field.required ? field.value !== "" : true) : false
            }
                
            );
            if (formIsAnswered) {
                setErrorFields(false);
            }
        }
    }, [eligibilityAnswers]);

    /**Passing the dynamic error message with primary and secondary */
    const displayError = (errorMessage, errmsg) => {
        setLoading(false);
        setErrorInForm((prev) => {
            return {
                ...prev,
                ...{
                    message: errorMessage || customErrors.genericError,
                    genericMessage: errmsg,
                    error: true,
                },
            };
        });
    };

    const handleOnFormAnswered = (answers) => {
        const formIsAnswered = getFormAnswers(answers, questions).every(
            (field) => {
                return field.required ? field.value !== "" : true;
            }
        );
        if (formIsAnswered) {
            setErrorFields(false);
            const eligibilityAnswerChecked = getFormAnswers(answers, questions);
            setEligibilityAnswers(eligibilityAnswerChecked);
        } else {
            setErrorFields(true);
        }
    };

    /**function for question check for showing the error message */
    function questioncheck(data) {
        return eligibilityFormAnswers.find((answer) => answer.id === data)
            ? eligibilityFormAnswers.find((answer) => answer.id === data).value
            : "";
    }

    /**function for checking the questions dropdown value and showing the error message if not eligible for a particular question*/
    const homeDetailsQuestionCheck = () => {
        if (questioncheck("heat_system_type") === conditionSpecificBehaviors.cr_heating_value
         || questioncheck("heat_system_type") === conditionSpecificBehaviors?.cr_heating_selectedValue
           ) {
            displayError(
                conditionSpecificBehaviors?.cr_heatingPrimaryError,
                conditionSpecificBehaviors?.cr_heatingSecondaryError
            );
        } else {
            setLoading(false);
            handleNext(true);
        }
    };

    const handleSubmit = (evt) => {
        setLoading(true);
        evt.preventDefault();
        setAccountState((prevAccountState) => ({
            ...prevAccountState,
            answers: {
                ...prevAccountState.answers,
                eligibility: [...eligibilityFormAnswers],
            },
        }));

        if (conditionSpecificBehaviors?.cr_heating_type_check) {
            homeDetailsQuestionCheck();
        } else {
            setLoading(false);
            handleNext(true);
        }
    };

    return (
        <FormBuilder
            questions={questions}
            answers={eligibilityFormAnswers}
            onFormAnswered={handleOnFormAnswered}
            handleSubmit={handleSubmit}
            formInstructions={
                group.instructions || "Fill out the information below to verify that you are eligible for this coupon."
            }
            extraInfoAfterRequired={group.extraInfoAfterRequired}
            requiredFieldsSubtitule={true}
        >
            <StepperNavigationButtons
                handleBack={handleBack}
                handleNext={() => null}
                loading={loading}
                nextButtonDisabled={errorFields}
            />
        </FormBuilder>
    );
}

export default withErrorHandler(EligibilityQuestionsForm);
